
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingItemsGrid extends Serenity.EntityGrid<MeltingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MeltingItems'; }
        protected getDialogType() { return MeltingItemsDialog; }
        protected getIdProperty() { return MeltingItemsRow.idProperty; }
        protected getInsertPermission() { return MeltingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MeltingItemsRow.localTextPrefix; }
        protected getService() { return MeltingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}